import React from 'react'
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import OneModal from '../../../Components/OneModal/OneModal'
import { Button, Typography } from '@mui/material'
import { textoSx } from './ModalConfirmacaoEventoSx'
import { showNotify } from '../../../Utils/Utils'

export default function ModalConfirmacaoEvento({
    open,
    setOpen,
    descricaoEvento,
    nomeOperadorAtual,
    mudarStatusEvento
}) {
    const handleMudarStatusEvento = () => {
        mudarStatusEvento()
        setOpen(false)
        showNotify('success', 'Evento assumido com sucesso.')
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText={descricaoEvento}
            FooterButtons={() => footerButtons(setOpen, handleMudarStatusEvento)}
            maxWidth='xs'
        >
            <Grid sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>

                <Typography sx={textoSx}>O evento está sendo tratado pelo operador {nomeOperadorAtual}.</Typography>

                <Typography sx={textoSx}>Deseja assumir o evento?</Typography>
            </Grid>
        </OneModal >
    )
}

function footerButtons(setOpen, handleMudarStatusEvento) {
    return (
        <Grid container xs={12} sx={{ justifyContent: 'space-between', width: '100%' }}>
            <Button color="error" variant="contained" onClick={() => setOpen(false)} > Não </Button>
            <Button color="success" variant="contained" onClick={() => handleMudarStatusEvento()}> Sim </Button>
        </Grid >
    )
}
